import React from "react";

const steps = [
  {
    numero: "01",
    titulo: "Conversa no WhatsApp",
    duvida: "Não sei nem explicar o que eu preciso.",
    texto: "Você conta onde está o gargalo no seu processo, do seu jeito. Sem compromisso e sem formulário.",
  },
  {
    numero: "02",
    titulo: "Diagnóstico",
    duvida: "Será que vai encaixar no meu processo?",
    texto: "Visitamos a sua empresa, mapeamos o processo no dia a dia e apontamos o que resolver primeiro.",
  },
  {
    numero: "03",
    titulo: "Proposta",
    duvida: "Vai estourar o orçamento e o prazo.",
    texto: "Orçamento gratuito, com escopo e prazo definidos antes de qualquer trabalho começar.",
  },
  {
    numero: "04",
    titulo: "Desenvolvimento e entrega",
    duvida: "E depois que entregar, eu fico na mão?",
    texto: "Você acompanha o andamento, recebe o sistema implantado na sua operação e tem suporte depois da entrega.",
  },
];

const Process = () => {
  return (
    <div className="scroll-mt-24 xl:scroll-mt-32" id="como-funciona">
      <div className="bg-gray-50">
      <div className="text-black w-3/4 mx-auto xl:py-32 py-16">
        <p className="text-sm font-semibold uppercase tracking-widest text-pattern-dark mb-4 xl:text-center">Método Hawx</p>
        <h2 className="text-3xl xl:text-5xl font-semibold xl:text-center mb-6">
          Do gargalo no processo ao sistema rodando
        </h2>
        <p className="text-xl leading-relaxed text-gray-700 xl:text-center xl:w-2/3 xl:mx-auto mb-12 xl:mb-20">
          Hoje você está no ponto A: a operação dependendo do esforço manual da equipe. O ponto Z é ela rodando em um sistema feito para ela. São quatro etapas para chegar lá, e cada uma responde a uma dúvida que todo cliente tem.
        </p>
        <ol className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-10 xl:gap-8">
          {steps.map((step) => (
            <li key={step.numero} className="border-t-2 border-pattern pt-6">
              <p className="font-display text-4xl font-bold text-pattern mb-4">{step.numero}</p>
              <h3 className="text-xl xl:text-2xl font-semibold mb-3">{step.titulo}</h3>
              <p className="text-base text-gray-500 italic mb-3">{`“${step.duvida}”`}</p>
              <p className="text-lg leading-relaxed text-gray-700">{step.texto}</p>
            </li>
          ))}
        </ol>
      </div>
      </div>
      <div className="fade-gray-to-white" aria-hidden="true" />
    </div>
  );
};

export default Process;
